import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SELECT_CHILD] (state, child) {
        state.selectedChild = child;
    },

    [types.SET_CALENDAR_ACTIVITY_DATES] (state, activityDates) {
        state.activityDates = activityDates;
    },

    [types.SELECT_CALENDAR_DATE] (state, date) {
        state.date = date;
    },

    [types.SELECT_CALENDAR_MODE] (state, mode) {
        state.mode = mode;
    },

    [types.TOGGLE_CALENDAR_DROPDOWN_CHILD] (state, isChildDropdown) {
        state.isChildDropdown = isChildDropdown;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/calendar/mutations.js